import {Model, ModelMixin} from '../common/model.class';

export class AdminReports extends ModelMixin() implements Model<AdminReports> {

    TYPE = AdminReports;

    constructor(jsonData: any = {}) {
        super();
        Object.assign(this, jsonData);
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/domain/model/admin-reports/admin-reports.model.ts